import { useIntl } from 'react-intl';

const renderAutoCompleteLocaleText = () => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const intl = useIntl();

  return {
    clearText: intl.formatMessage({ id: 'autocomplete.clearText', defaultMessage: 'Temizle' }),
    closeText: intl.formatMessage({ id: 'autocomplete.closeText', defaultMessage: 'Kapat' }),
    loadingText: intl.formatMessage({ id: 'autocomplete.loadingText', defaultMessage: 'Yükleniyor...' }),
    noOptionsText: intl.formatMessage({ id: 'autocomplete.noOptionsText', defaultMessage: 'Kayıt bulunamadı' }),
    openText: intl.formatMessage({ id: 'autocomplete.openText', defaultMessage: 'Aç' }),
  };
};

export default renderAutoCompleteLocaleText;
